export default __webpack_public_path__ + "static/with-coffee-tablet-3fa2decd24631b59e1657677598968f9.png";